(() => {
  const CARD_SELECTOR = '[data-depth-product-card]';
  const canTilt = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initializedCards = new WeakSet();

  const resetCard = (card) => {
    card.removeAttribute('data-depth-active');
    card.style.setProperty('--depth-card-rotate-x', '0deg');
    card.style.setProperty('--depth-card-rotate-y', '0deg');
    card.style.setProperty('--depth-card-shift-x', '0px');
    card.style.setProperty('--depth-card-shift-y', '0px');
    card.style.setProperty('--depth-card-spot-x', '50%');
    card.style.setProperty('--depth-card-spot-y', '50%');
  };

  const initializeCard = (card) => {
    if (initializedCards.has(card)) return;
    initializedCards.add(card);

    let animationFrame;
    let pointerX = 0;
    let pointerY = 0;

    const render = () => {
      animationFrame = undefined;

      if (!canTilt.matches || reduceMotion.matches) {
        resetCard(card);
        return;
      }

      const bounds = card.getBoundingClientRect();
      const normalizedX = Math.max(-1, Math.min(1, ((pointerX - bounds.left) / bounds.width - 0.5) * 2));
      const normalizedY = Math.max(-1, Math.min(1, ((pointerY - bounds.top) / bounds.height - 0.5) * 2));

      card.dataset.depthActive = 'true';
      card.style.setProperty('--depth-card-rotate-x', `${(-normalizedY * 6).toFixed(2)}deg`);
      card.style.setProperty('--depth-card-rotate-y', `${(normalizedX * 6).toFixed(2)}deg`);
      card.style.setProperty('--depth-card-shift-x', `${(normalizedX * 3).toFixed(2)}px`);
      card.style.setProperty('--depth-card-shift-y', `${(normalizedY * 3).toFixed(2)}px`);
      card.style.setProperty('--depth-card-spot-x', `${((normalizedX + 1) * 50).toFixed(1)}%`);
      card.style.setProperty('--depth-card-spot-y', `${((normalizedY + 1) * 50).toFixed(1)}%`);
    };

    card.addEventListener('pointermove', (event) => {
      pointerX = event.clientX;
      pointerY = event.clientY;
      if (!animationFrame) animationFrame = requestAnimationFrame(render);
    });

    card.addEventListener('pointerleave', () => {
      if (animationFrame) cancelAnimationFrame(animationFrame);
      animationFrame = undefined;
      resetCard(card);
    });
  };

  const initializeCards = (root = document) => {
    if (root.matches?.(CARD_SELECTOR)) initializeCard(root);
    root.querySelectorAll?.(CARD_SELECTOR).forEach(initializeCard);
  };

  const resetAllCards = () => document.querySelectorAll(CARD_SELECTOR).forEach(resetCard);

  initializeCards();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) initializeCards(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });

  canTilt.addEventListener?.('change', resetAllCards);
  reduceMotion.addEventListener?.('change', resetAllCards);
  document.addEventListener('shopify:section:load', (event) => initializeCards(event.target));
})();
